// This file is generated using scripts/generate-icon-components/utils.js
// Don't edit it manually

import React from 'react';

const IconOutlineLink2 = (
  {
    size,
    style,
    ...rest
  }: React.HTMLAttributes<SVGElement> & { size?: number } /*#__PURE__*/,
) =>
  React.createElement(
    'svg',
    {
      style: { width: size, height: size, ...style },
      ...rest,
      width: '24',
      height: '24',
      viewBox: '0 0 24 24',
      fill: 'none',
      xmlns: 'http://www.w3.org/2000/svg',
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M8.98969 21.5001C7.32969 21.5001 5.65969 20.8701 4.38969 19.6001C1.85969 17.0601 1.85969 12.9401 4.38969 10.4101C4.67969 10.1201 5.15969 10.1201 5.44969 10.4101C5.73969 10.7001 5.73969 11.1801 5.44969 11.4701C3.49969 13.4201 3.49969 16.5901 5.44969 18.5401C7.39969 20.4901 10.5697 20.4901 12.5197 18.5401C13.4597 17.6001 13.9797 16.3401 13.9797 15.0001C13.9797 13.6701 13.4597 12.4101 12.5197 11.4601C12.2297 11.1701 12.2297 10.6901 12.5197 10.4001C12.8097 10.1101 13.2897 10.1101 13.5797 10.4001C14.8097 11.6301 15.4797 13.2601 15.4797 15.0001C15.4797 16.7401 14.7997 18.3701 13.5797 19.6001C12.3197 20.8701 10.6597 21.5001 8.98969 21.5001Z',
      fill: 'currentColor',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.0701 14.1602C18.8801 14.1602 18.6901 14.0902 18.5401 13.9402C18.2501 13.6502 18.2501 13.1702 18.5401 12.8802C20.5901 10.8302 20.5901 7.50023 18.5401 5.46023C16.4901 3.41023 13.1601 3.41023 11.1201 5.46023C10.1301 6.45023 9.58008 7.77023 9.58008 9.17023C9.58008 10.5702 10.1301 11.8902 11.1201 12.8802C11.4101 13.1702 11.4101 13.6502 11.1201 13.9402C10.8301 14.2302 10.3501 14.2302 10.0601 13.9402C8.79008 12.6702 8.08008 10.9702 8.08008 9.17023C8.08008 7.37023 8.78008 5.67023 10.0601 4.40023C12.6901 1.77023 16.9701 1.77023 19.6101 4.40023C22.2401 7.03023 22.2401 11.3202 19.6101 13.9502C19.4601 14.0902 19.2601 14.1602 19.0701 14.1602Z',
      fill: 'currentColor',
    }),
  );

export { IconOutlineLink2 };
